import { STORE_URL } from '#src/constants/externalLinks.ts';
import { localStorage } from '#src/lib/storage/localStorage.ts';

type Options = {
  invitationToken?: string | null;
  impactId?: string | null;
  referrer?: string | null;
  googleClickId?: string | null;
  facebookClickId?: string | null;
  twitterClickId?: string | null;
  tikTokClickId?: string | null;
  snapchatClickId?: string | null;
  redditClickId?: string | null;
};

const useOneLinkUrl = (
  href: string,
  {
    invitationToken,
    impactId,
    referrer,
    googleClickId,
    facebookClickId,
    twitterClickId,
    tikTokClickId,
    snapchatClickId,
    redditClickId,
  }: Options
) => {
  const url = new URL(href);
  if (invitationToken) {
    url.searchParams.append('deep_link_sub1', invitationToken);
  }
  if (impactId) {
    url.searchParams.append('deep_link_sub2', impactId);
  }
  if (referrer) {
    url.searchParams.append('deep_link_sub3', `referrer:${referrer}`);
  }
  if (googleClickId) {
    url.searchParams.append('deep_link_sub3', `gclid:${googleClickId}`);
  }
  if (facebookClickId) {
    url.searchParams.append('deep_link_sub3', `fbclid:${facebookClickId}`);
  }
  if (twitterClickId) {
    url.searchParams.append('deep_link_sub3', `twclid:${twitterClickId}`);
  }
  if (tikTokClickId) {
    url.searchParams.append('deep_link_sub3', `ttclid:${tikTokClickId}`);
  }
  if (snapchatClickId) {
    url.searchParams.append('deep_link_sub3', `ScCid:${snapchatClickId}`);
  }
  if (redditClickId) {
    url.searchParams.append('deep_link_sub3', `rdt_cid:${redditClickId}`);
  }

  return url.href;
};

export const useStoreUrl = () => {
  const referrer = localStorage.getItem('REFERRER');
  const impactId = localStorage.getItem('IMPACT_CLICKID');
  const googleClickId = localStorage.getItem('GOOGLE_CLICKID');
  const facebookClickId = localStorage.getItem('FACEBOOK_CLICKID');
  const twitterClickId = localStorage.getItem('TWITTER_CLICKID');
  const tikTokClickId = localStorage.getItem('TIKTOK_CLICKID');
  const snapchatClickId = localStorage.getItem('SNAPCHAT_CLICKID');
  const redditClickId = localStorage.getItem('REDDIT_CLICKID');
  const invitationToken = localStorage.getItem('INVITATION_TOKEN');

  return useOneLinkUrl(STORE_URL, {
    invitationToken,
    impactId,
    googleClickId,
    facebookClickId,
    twitterClickId,
    tikTokClickId,
    snapchatClickId,
    redditClickId,
    referrer,
  });
};
